module.exports = {
    name: "Morgan",

    base: {
        contact_address: "FREEPOST MORGAN",
        contact_number: "0800 915 2493 (option 1)",
        contact_email: "info@morganoffshorewind.com",
    },

    locations: [
        {
            "title": "Blackpool",
            "existingVideoId": "718214474",
            "proposedVideoId": "718215332",
            "lat": 53.816950,
            "lng": -3.055990
        },

        {
            "title": "Douglas",
            "existingVideoId": "718214520",
            "proposedVideoId": "718215363",
            "lat": 54.142605,
            "lng": -4.466485
        },

        {
            "title": "Moel Famau",
            "existingVideoId": "718214564",
            "proposedVideoId": "718215401",
            "lat": 53.154495,
            "lng": -3.255903
        },

        {
            "title": "Rhyl Beach",
            "existingVideoId": "718214608",
            "proposedVideoId": "718215432",
            "lat": 53.325460,
            "lng": -3.488189
        },

        {
            "title": "Great Orme",
            "existingVideoId": "718214642",
            "proposedVideoId": "718215474",
            "lat": 53.332744,
            "lng": -3.850811
        },

        {
            "title": "Yr Wyddfa",
            "existingVideoId": "718214691",
            "proposedVideoId": "718215526",
            "lat": 53.068480,
            "lng": -4.076018
        },

        {
            "title": "Parys Mountain",
            "existingVideoId": "718214738",
            "proposedVideoId": "718215582",
            "lat": 53.383295,
            "lng": -4.349348
        },

        {
            "title": "Point Lynas Lighthouse",
            "existingVideoId": "718214827",
            "proposedVideoId": "718215673",
            "lat": 53.415920,
            "lng": -4.289512
        },

        {
            "title": "Bull Bay",
            "existingVideoId": "718214779",
            "proposedVideoId": "718215632",
            "lat": 53.416944,
            "lng": -4.362252
        },

        {
            "title": "Penmon Point",
            "existingVideoId": "718214853",
            "proposedVideoId": "718215711",
            "lat": 53.310861,
            "lng": -4.041043
        }
    ],

    consultation: {
        mapId: 2,
        mapSlug: "/morgan/map",

         // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
         mapUrl: "https://feedback.morecambeandmorgan.com",

        feedback_active: false,
        closed_message:
            "This consultation is closed and is no longer accepting feedback.",

        // Consultation close countdown. If set to true, show countdown in site header
        has_countdown: false,

        hasMap: false,

        themes: [
            {
                name: "General",
                url: "section-1",
                feedback_url: "",
                icon: "uncategorised",
                question:
                    "Do you have any comments or feedback on the project to date generally, including the specific topics listed (see numbered topics 1.1 to 1.14 below).",
                key: "01-morgan-section",
                topics: [
                    {
                        "key": "01-morgan-question-01-topic",
                        "question": "Physical processes"
                    },

                    {
                        "key": "01-morgan-question-02-topic",
                        "question": "Benthic subtidal ecology"
                    },

                    {
                        "key": "01-morgan-question-03-topic",
                        "question": "Fish and shellfish ecology"
                    },

                    {
                        "key": "01-morgan-question-04-topic",
                        "question": "Marine mammals"
                    },

                    {
                        "key": "01-morgan-question-05-topic",
                        "question": "Offshore ornithology"
                    },

                    {
                        "key": "01-morgan-question-06-topic",
                        "question": "Commercial fisheries"
                    },

                    {
                        "key": "01-morgan-question-07-topic",
                        "question": "Shipping and navigation"
                    },

                    {
                        "key": "01-morgan-question-08-topic",
                        "question": "Marine archaeology"
                    },

                    {
                        "key": "01-morgan-question-09-topic",
                        "question": "Infrastructure and other users, offshore"
                    },

                    {
                        "key": "01-morgan-question-10-topic",
                        "question": "Seascape, Landscape and Visual Impact Assessment (SLVIA)"
                    },

                    {
                        "key": "01-morgan-question-11-topic",
                        "question": "Civil and military aviation and radar"
                    },

                    {
                        "key": "01-morgan-question-12-topic",
                        "question": "Climate change"
                    },

                    {
                        "key": "01-morgan-question-13-topic",
                        "question": "Socioeconomics, tourism and recreation"
                    },

                    {
                        "key": "01-morgan-question-14-topic",
                        "question": "Human health"
                    },
                ]
            },
            {
                name: "Technical & environmental",
                url: "section-2",
                feedback_url: "page-2/",
                icon: "environment",
                question:
                    "Do you have any comments or feedback on how we have understood the technical and environmental constraints of the areas offered to us by the Crown Estate as part of its leasing process?",
                key: "02-morgan-section",
            },
            {
                name: "Community",
                url: "section-3",
                feedback_url: "page-3/",
                icon: "community",
                question:
                    "Do you have any comments/ feedback on the possible community benefits of the Morgan Offshore Wind Project Generation Assets, and how the project can support the local, regional and national economy?",
                key: "03-morgan-section",
            },
            {
                name: "Construction",
                url: "section-4",
                feedback_url: "page-4/",
                icon: "construction",
                question:
                    "Do you have any comments/ feedback on how we are proposing to construct, operate and maintain Morgan Offshore Wind Project Generation Assets?",
                key: "04-morgan-section",
            },
            {
                name: "Commercial impact",
                url: "section-5",
                feedback_url: "page-5/",
                icon: "commercial",
                question:
                    "Do you have any comments/ feedback on how the project interacts with commercial fisheries, shipping and navigation?",
                key: "05-morgan-section",
            },
            {
                name: "General",
                url: "section-6",
                feedback_url: "page-6/",
                icon: "uncategorised",
                question:
                    "Do you have any comments/ feedback on the project, including any other information provided as a part of this consultation?",
                key: "06-morgan-section",
            },
        ],
    },

    examination: {
		examination: {
			index: 12,

			title: "Examination",
			downloads: [
                {
                    title: "Notice of Issue-Specific Hearing - January 2025",
                    url: "/assets/images/shared/downloads/morgan/FINAL_Morgan-Hearings-notice-12-Feb.pdf",
                },
                                {
                    title: "Notice of Issue-Specific Hearing - November 2024",
                    url: "/assets/images/shared/downloads/morgan/FINAL-Morgan-Hearings-notice-25-Nov.pdf",
                },
                {
                    title: "Notice of Issue-Specific Hearing - August 2024",
                    url: "/assets/images/shared/downloads/morgan/Morgan-Hearings-notice.pdf",
                }
			]
		},
    },

    acceptanceMaterials: {
		acceptance: {
			index: 11,

			title: "Acceptance for examination",
			downloads: [
                {
                    title: "Morgan Offshore Wind Limited Section 56 Planning Act 2008",
                    url: "/assets/images/shared/downloads/morgan/Morgan-Offshore-Wind-Limited-Section-56-Planning-Act-2008.pdf",
                }
			]
		},
    },

    postMaterials: {
		post: {
			index: 10,

			title: "Post-consultation",
			downloads: [
                {
                    title: "Project update: Autumn 2023",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/MORGAN_GEN_Newsletter.pdf",
                }
			]
		},
    },

	statConsultationMaterials: {
		plansDrawings: {
			index: 0,

			title: "Plans and Drawings",
			downloads: [
                {
                    title: "Location plan(s) (Offshore)",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/01+Plans+and+Drawings/RPS_EOR0801_Morgan+Gen_Location+Plan.pdf",
                },
				{
					title: "Works plan - Offshore",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/01+Plans+and+Drawings/RPS_EOR0801_Morgan+Gen_Offshore+Works+Plan+FINAL.pdf",
				},
                {
                    title: "Indicative Extent of Marine Licenses",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/01+Plans+and+Drawings/RPS_EOR0801_Morgan+Gen_IEML.pdf",
                }
			]
		},

		dco: {
			index: 1,

			title: "Development Consent Order",
			downloads: [
                {
                    title: "Draft Development Consent Order including Draft Deemed Marine Licences",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/02+Development+Consent+Order/Morgan_Draft_DCO.pdf",
                },
                {
                    title: "Explanatory Memorandum",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/02+Development+Consent+Order/Morgan_Draft+DCO+Explanatory+Note.pdf",
                }

			]
		},

		reports: {
			index: 2,

			title: "Reports",
			downloads: [
				{
					title: "Information to Support Appropriate Assessment",
					url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/03+Reports/RPS_EOR0801_Morgan_ISAA_FINAL.pdf",
				},
				{
					title: "HRA Screening Report, Screening Matrices and Integrity Matrices",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/03+Reports/RPS_EOR0801_Morgan_Other_LSE+Screening+FINAL.pdf",
                },
				{
					title: "Marine Conservation Zone Assessment",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/03+Reports/RPS_EOR0801_Morgan_PEIR_MCZ+Screening.pdf",
                },

			]
		},

		peir: {
			title: "PEIR",

            introduction: {
				index: 3,

				title: "PEIR Volume 1: Introductory Chapters",
				downloads: [
					{
                        title: "1. Introduction and Overarching Glossary",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Morgan_PEIR_Vol1_1_Intro.pdf",
                    },
                    {
                        title: "2. Policy and Legislation",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Morgan_PEIR_Vol1_2_Policy.pdf",
                    },
                    {
                        title: "3. Project Description",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Morgan_PEIR_Vol1_3_PD.pdf",
                    },
                    {
                        title: "4. Site Selection and Consideration of Alternatives",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Morgan_PEIR_Vol1_4_SSA.pdf",
                    },
                    {
                        title: "5. Environmental Impact Assessment Methodology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/01+-+Introductory+Chapters/RPS_EOR0801_Morgan_PEIR_Vol1_5_EIA+Method.pdf",
                    },

				],
			},

            offshoreChapters: {
				index: 4,

				title: "PEIR Volume 2: Offshore Chapters",
				downloads: [
                    {
                        title: "6. Physical Processes",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_PEIR_Vol2_6_PP_FINAL.pdf",
                    },
                    {
                        title: "7. Benthic Subtidal and Intertidal Ecology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_PEIR_Vol2_7_BE_FINAL.pdf",
                    },
                    {
                        title: "8. Fish and Shellfish Ecology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_Gen_PEIR_Vol2_8_FSF.pdf",
                    },
                    {
                        title: "9. Marine Mammals",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_PEIR_Vol2_9_MM.pdf",
                    },
                    {
                        title: "10. Offshore Ornithology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_PEIR_Vol2_10_OO.pdf",
                    },
                    {
                        title: "11. Commercial Fisheries",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_PEIR_Vol2_11_CF.pdf",
                    },
                    {
                        title: "12. Shipping and Navigation",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_PEIR_Morgan_Vol2_12_SN.pdf",
                    },
                    {
                        title: "13. Marine Archaeology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_PEIR_Vol2_13_MAR.pdf",
                    },
                    {
                        title: "14. Other Sea Users",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_PEIR_Vol2_14_OSU.pdf",
                    },
                    {
                        title: "15. Seascape Landscape and Visual Resources",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_PEIR_15_SLVIA-.pdf",
                    },
                    {
                        title: "16. Aviation and Radar",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_PEIR_Vol2_16_Aviation.pdf",
                    },
                    {
                        title: "17. Climate Change ",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan+G_PEIR_Vol2_17_CC.pdf",
                    },
                    {
                        title: "18. Socio-economics",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan+Gen+PEIR_Vol2_18_Socio-economics.pdf",
                    },
                    {
                        title: "19. Human Health Assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan_PEIR_Vol2_19_HH.pdf",
                    },
                    {
                        title: "20. Inter-related Effects - Offshore",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/02+-+Offshore+Chapters/RPS_EOR0801_Morgan+Gen_PEIR_Vol2_20_Inter-related.pdf",
                    }

				],
			},

            introductoryAnnexes: {
				index: 5,

				title: "PEIR Volume 3: Introductory Annexes",
				downloads: [
                    {
                        title: "3.1 Underwater Sound Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/03+-+Introductory+Annexes/RPS_EOR0801_Morgan_PEIR_Vol5_3.1_UWS+TR+FINAL.pdf",
                    },
                    {
                        title: "5.1 Cumulative Effects Screening Matrix",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/03+-+Introductory+Annexes/RPS_EOR0801_Morgan_PEIR_Vol5_5.1_CEA+Matrix.pdf",
                    },
                    {
                        title: "5.2 Transboundary Impacts Screening",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/03+-+Introductory+Annexes/RPS_EOR0801_Morgan_PEIR_Vol3_5.2_Transboundary.pdf",
                    }
				],
			},

            offshoreAnnexes: {
				index: 6,

				title: "PEIR Volume 4: Offshore Annexes",
				downloads: [
                    {
                        title: "6.1 Physical Processes Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol6_6.1_PP+TR_.pdf",
                    },
                    {
                        title: "7.1 Benthic Subtidal and Intertidal Ecology Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol6_7.1_BE+TR.pdf",
                    },
                    {
                        title: "8.1 Fish and Shellfish Ecology Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol6_8.1_FSF+TR.pdf",
                    },
                    {
                        title: "9.1 Marine Mammal Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol6_9.1_MMTR.pdf",
                    },
                    {
                        title: "10.1 Offshore Ornithology Baseline Characterisation Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol6_10.1_OOBaseline+TR+FINAL.pdf",
                    },
                    {
                        title: "10.2 Offshore Ornithology Displacement Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol6_10.2_OODisplacement+TR_FINAL.pdf",
                    },
                    {
                        title: "10.3 Offshore Ornithology Collision Risk Modelling Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol6_10.3_OO+CRM+TR_FINAL.pdf",
                    },
                    {
                        title: "10.4 Offshore Ornithology Migratory Bird Collision Risk Modelling Technical Report ",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol6_10.4_OO+Migratory+CRM+TR+FINAL.pdf",
                    },
                    {
                        title: "10.5 Offshore Ornithology Apportioning Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol6_10.5_OOApportioning+TR+FINAL.pdf",
                    },
                    {
                        title: "10.6 Offshore Ornithology Cumulative Effects Assessment Population Viability Assessment Technical Report ",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol4_10.6_OO+PVA+TR+FINAL.pdf",
                    },
                    {
                        title: "11.1 Commercial Fisheries Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol4_11.1_CFTR.pdf",
                    },
                    {
                        title: "12.1 Navigation Risk Assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol4_12.1_NRA+TR.pdf",
                    },
                    {
                        title: "13.1 Marine Archaeology Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol6_13.1_MARTR.pdf",
                    },
                    {
                        title: "15.1 Seascape, Landscape and Visual Resources Legislation and Planning Policy Context",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan+PEIR_vol4_15.1_SLVIA+Leg+%26+Planning+Policy+Context.pdf",
                    },
                    {
                        title: "15.2 Seascape and Landscape Character Baseline Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan+Gen_PEIR_Vol4_15.2_SLVIA+character+baseline.pdf",
                    },
                    {
                        title: "15.3 Visual Baseline Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol4_15.3_SLVIA+Visual+TR.pdf",
                    },
                    {
                        title: "15.4 Seascape, Landscape and Visual Resources Impact Assessment Methodology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan+PEIR_Vol4_15.4_SLVIA_Methodology+.pdf",
                    },
                    {
                        title: "16.1 Aviation and Radar Technical Report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol4_16.1_AR+TR.pdf",
                    },
                    {
                        title: "17.1 Technical Greenhouse Gas Assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan+G_PEIR_Vol4_17.1_GHG+Assessment.pdf",
                    },
                    {
                        title: "17.2 Climate Change Risk Assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_Morgan_PEIR_Vol4_17.2_CCRA.pdf",
                    },
                    {
                        title: "18.1 Socio-economics and community",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/04+-+Offshore+Annexes/RPS_EOR0801_PEIR_Morgan_Vol4_18.1_Socio-ec+TR.pdf",
                    },

				],
			},

            nts: {
				index: 7,

				title: "PEIR Volume 5: Non-Technical Summary",
				downloads: [
                    {
                        title: "Preliminary Environmental Information Report - Non-Technical Summary (PDF)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morgan/04+Preliminary+Environmental+Information+Report/NTS/Morgan+Gen_PEIR_Non-Technical+Summary.pdf",
                    },
                    {
                        title: "Preliminary Environmental Information Report - Non-Technical Summary (WEBSITE)",
                        url: "https://bp-morgan-nts.netlify.app",
                    },

				],
			},
		},

		consultationMaterials: {
			index: 9,

			title: "Statutory Consultation Materials",
			downloads: [
                {
                    title: "Statement of Community Consultation (SoCC)",
                    url: "/assets/images/shared/downloads/morgan/MORGAN-SOCC-V15_pages.pdf",
                },
                {
                   title: "Consultation Brochure (Single pages)",
                   url: "/assets/images/shared/downloads/morgan/Morgan-Offshore-Wind-Project-Generation-Assets-statutory-consultation-brochure-UPDATE_pages.pdf",
                   date: "Updated 04/05/23",
                },
                {
                   title: "Consultation Brochure (Spread pages)",
                   url: "/assets/images/shared/downloads/morgan/Morgan-Offshore-Wind-Project-Generation-Assets-statutory-consultation-brochure-UPDATE_Spreads.pdf",
                   date: "Updated 04/05/23",
                },
                {
                    title: "Deposit Locations",
                    url: "/assets/images/shared/downloads/morgan/Morgan-deposit-locations.pdf",
                },
                {
                    title: "Feedback Form",
                    url: "/assets/images/shared/downloads/morgan/MORGAN-Feedback Form_LR.pdf",
                },
                {
                    title: "Consultation Poster",
                    url: "/assets/images/shared/downloads/MMMT-Poster.pdf",
                },
                {
                    title: "Section 42 Notice",
                    url: "/assets/images/shared/downloads/morgan/Morgan-Offshore-Wind-Project-Generation-Assets-Statutory-Consultation-S42-Notice.pdf",
                },
                {
                    title: "Section 47 Notice",
                    url: "/assets/images/shared/downloads/morgan/Morgan-Offshore-Wind-Project-Generation-Assets-section-47-notice.pdf",
                },
                {
                    title: "Section 48 Notice",
                    url: "/assets/images/shared/downloads/morgan/Morgan-Offshore-Wind-Project-Section-48-Notice-FINAL.pdf",
                },
                {
                    title: "Morgan Offshore Wind Project Webinar - 3rd May 2023",
                    videoId: "825227099",
                    type: "video",               
                },
			]
		},
    },

    nonstatConsultationMaterials: [
        {
            title: "Morecambe and Morgan consultation brochure - Autumn 2022",
            url: "/assets/images/shared/downloads/M&M-Condoc.pdf",
        },
        {
            title: "Recording of online consultation event",
            videoId: "774795335",
            type: "video",
        },
    ],

    scoping: [
        {
            title: "Morgan Offshore Wind Project Environmental Impact Assessment Scoping Report",
            url: "/assets/images/shared/downloads/morgan/Morgan_Offshore_Wind_Farm_EIA_Scoping_Report.pdf",
        },
    ]
};
